import { Component, Input } from '@angular/core';
import { VersionHistoryChangesPanelComponent } from '@components/version-history-changes-panel/version-history-changes-panel.component';

@Component({
    selector: 'app-ops-changes-panel',
    templateUrl: './ops-changes-panel.component.html',
    styleUrls: ['../version-history-changes-panel/version-history-changes-panel.component.css'],
    standalone: false,
})
export class OpsChangesPanelComponent extends VersionHistoryChangesPanelComponent {
    @Input() changes: { old: number; new: number };
    @Input() numberOPS?: number;
}
